import { useState, type FC, type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";

import { createDemoQueryClient } from "@/pages/demo/DemoQueryClient";
import { DemoModeProvider } from "@/pages/demo/DemoModeContext";
import { DemoAppContextProvider } from "@/pages/demo/DemoAppContextProvider";
import { DemoBanner } from "@/pages/demo/DemoBanner";

export const DemoProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [queryClient] = useState(() => createDemoQueryClient());

  return (
    <DemoModeProvider>
      <QueryClientProvider client={queryClient}>
        <DemoAppContextProvider>
          <div className="h-screen flex flex-col overflow-hidden">
            <DemoBanner />
            {children}
          </div>
        </DemoAppContextProvider>
      </QueryClientProvider>
    </DemoModeProvider>
  );
};
